import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';

export function LargeNewThreadButton({ handleClick }) {
  return (
    <button
      onClick={handleClick}
      className="hidden w-full items-center justify-center gap-2 rounded-full bg-indigo-400/50 px-3 py-4 text-lg font-semibold opacity-80 shadow-md hover:bg-indigo-400/60 hover:opacity-90 hover:shadow-lg supports-[backdrop-filter]:backdrop-blur dark:bg-indigo-800/50 dark:hover:bg-indigo-800/60 lg:flex lg:shadow-none"
    >
      <Icon icon="ph:plus-bold" />
      New Thread
    </button>
  );
}

LargeNewThreadButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
